import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-6" }
const _hoisted_2 = { class: "sm:mx-6 md:mx-8 bg-white shadow overflow-x-auto sm:rounded-md" }
const _hoisted_3 = { class: "shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg" }
const _hoisted_4 = { class: "max-w-full overflow-x-auto" }

import { inject, onMounted, ref, watch } from "vue";
import { AxiosInstance } from "axios";
import Pagination from "@/components/tools/Pagination.vue";
import { useRoute } from "vue-router";
import DataTable from "@/components/tools/DataTable.vue";
import stringify from "qs-stringify";
import "dayjs/locale/th";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { formatNumber, translate } from "@/utils/tools";
import { SearchIcon } from "@heroicons/vue/solid";
import UserSubEventDialogs from "../../components/dialogs/UserSubEventDialog.vue";
import { useStore } from "vuex";
import router from "@/router";

export default /*#__PURE__*/_defineComponent({
  __name: 'UserEvent',
  setup(__props) {

dayjs.extend(localizedFormat);

const axios = inject("$axios") as AxiosInstance;
const route = useRoute();
const dataRows = ref([]);
const isLoaded = ref(false);
const resettleData = ref({});
const selectedRow = ref({});
const user_event_id = ref();
const detailDialogModal = ref<boolean>(false);
const showErrorDetail = ref<boolean>(false);
const store = useStore();
const columns = ref([
  {
    label: translate("messages.event.eventName"),
    field: "event_name",
    isSorted: false,
    sort: true,
  },
  {
    label: translate("messages.event.percent"),
    field: "percent",
    // isSorted: false,
    // sort: true,
  },
  {
    label: translate("messages.event.success"),
    field: "is_success",
    // isSorted: false,
    // sort: true,
    class: (data: any) => {
      if (data.is_success) {
        return "inline-block text-xs py-1 px-2 rounded-lg bg-green-500 text-white";
      }
      return "inline-block text-xs py-1 px-2 rounded-lg bg-red-500 text-white";
    },
  },
  {
    label: translate("messages.event.claim"),
    field: "is_claim",
    // isSorted: false,
    // sort: true,
    class: (data: any) => {
      if (data.is_claim) {
        return "inline-block text-xs py-1 px-2 rounded-lg bg-green-500 text-white";
      }
      return "inline-block text-xs py-1 px-2 rounded-lg bg-red-500 text-white";
    },
  },
  {
    label: translate("messages.event.startDate"),
    field: "start_at",
    align: "left",
    sort: true,
    isSorted: false,
    format: (data: any) => dayjs(data.start_at).add(-7, 'hour').locale("th").format("LLL"),
  },
  {
    label: translate("messages.event.endDate"),
    field: "end_at",
    align: "left",
    // sort: true,
    // isSorted: false,
    format: (data: any) => dayjs(data.end_at).add(-7, 'hour').locale("th").format("LLL"),
  },
  {
    label: translate("messages.event.userSubEvent"),
    field: "action",
    sort: false,
    isButton: true,
    isRow: true,
    buttonTitle: "View",
  },
  // {
  //   label: "",
  //   field: "sub_event",
  //   isFunction: true,
  //   class: () =>
  //     "cursor-pointer inline-flex border border-transparent rounded-md  bg-blue-500 hover:bg-blue-600 text-white bg-blue-500 hover:bg-blue-600 ",
  //   // "cursor: pointer; inline-flex items-center px-3 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-600",
  //   auxClick: (data: any) => window.open(`event/user-event/${data.event_id}`),
  //   function: (data: any) => showDetailDialog(),
  // },
]);

const pageConfig = ref({
  page: 1,
  dataLength: 0,
  count: 0,
  pageCount: 0,
  rowsPerPage: 10,
  search: "",
  sort: [["seq_num", "DESC"]],
});

const filterModal = (flag?: number) => {
  // if (flag === 1) {
  //   fetchPageData(true);
  // } else {
  //   fetchPageData(false);
  // }
  // advanceFilterModal.value = false;
  detailDialogModal.value = false;
};

const fetchPageData = async () => {
  isLoaded.value = false;
  // console.log("route.params.id : ",route.params.id)
  const { page, rowsPerPage, sort, search } = pageConfig.value;
  // const { name, reward_type } = filterForm.value;

  const payload = {
    page,
    operatorId: store.state.selectedOperator.operatorId,
    user_id: route.params.id,
    name: search || null,
    pageSize: rowsPerPage,
    orderBy: [sort[0]],
  };

  const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/event/api/user-events/list-view`;
  const { rows } = await axios
    .post(url, payload, {
      headers: {
        "x-cm-operator-id": store.state.selectedOperator.operatorId,
      },
    })
    .then(({ data }) => data)
    .catch(()=>{
      isLoaded.value = true;
    });

  const newArray = rows.map((obj: any) => {
    return {
      ...obj,
      sub_event: "View",
    };
  });

  dataRows.value = newArray;
  pageConfig.value.dataLength = rows.length;

  // console.log("data event reward : ", dataRows.value);

  pageConfig.value = {
    ...pageConfig.value,
  };

  selectedRow.value = {};

  /** update url to persist page config */
  window.history.replaceState({}, document.title, `?${stringify({ page, rowsPerPage })}`);
  isLoaded.value = true;
};


const showDetailDialog = async (data: any) => {
  // console.log("data : ",data)
  detailDialogModal.value = true;
  user_event_id.value = data.id;
  // console.log("event_id : ",event_id)
};

const doSort = (attName: string) => {
  // console.log("attName : ", attName);
  // not working
  const index = columns.value.findIndex((column) => column.label === attName);
  if (!columns.value[index].sort) {
    return;
  }

  columns.value[index].isSorted = !columns.value[index].isSorted;
  const { sort } = pageConfig.value;
  const mode = sort[0][1];
  let formattedAttName;
  if (attName.toLocaleLowerCase() === "event name") formattedAttName = "event_name";
  //   if (attName === "Date Created") formattedAttName = "id";
  if (attName.toLocaleLowerCase() === "start date") formattedAttName = "seq_num";
  if (attName.toLocaleLowerCase() === "end date") formattedAttName = "end_at";
  sort[0] = [formattedAttName || attName.toLowerCase(), mode === "DESC" ? "ASC" : "DESC"];
  fetchPageData();
};

watch(
  () => pageConfig.value.page,
  () => fetchPageData()
);
/** fetch data when rows per page was changed */
watch(
  () => pageConfig.value.rowsPerPage,
  () => {
    pageConfig.value.page = Number(route.query.page) || 1;
    fetchPageData();
  }
);
onMounted(() => {
  pageConfig.value.page = Number(route.query.page) || 1;
  pageConfig.value.rowsPerPage = Number(route.query.rowsPerPage) || 10;
  fetchPageData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(DataTable, {
              columns: columns.value,
              data: dataRows.value,
              onSort: doSort,
              onShowDetailTable: showDetailDialog,
              isLoaded: isLoaded.value
            }, null, 8, ["columns", "data", "isLoaded"])
          ]),
          _createVNode(Pagination, {
            config: pageConfig.value,
            "onUpdate:config": _cache[0] || (_cache[0] = ($event: any) => ((pageConfig).value = $event))
          }, null, 8, ["config"])
        ])
      ])
    ]),
    _createVNode(UserSubEventDialogs, {
      show: detailDialogModal.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((detailDialogModal).value = $event)),
      id: user_event_id.value,
      onSubmit: _cache[2] || (_cache[2] = ($event: any) => (filterModal(0))),
      onPageChange: _cache[3] || (_cache[3] = (e) => showDetailDialog(selectedRow.value))
    }, null, 8, ["show", "id"])
  ], 64))
}
}

})